import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import { Dropdown, Offcanvas } from "react-bootstrap";
import SimpleBar from "simplebar-react";
import api from "../../../services/auth/api";
import { Card, Form, Row, Col, Button } from "react-bootstrap";
import { FaUserAlt } from 'react-icons/fa';
import {
  Logo,
  Image,
  Icon,
  MediaGroup,
  MediaText,
  MediaAction,
  Media,
  LinkList,
  LinkListItem,
  CustomDropdownToggle,
  CustomDropdownMenu,
} from "../../../components";
import Menu from "./Menu";
import ToggleSidebar from "../Toggle/Sidebar";
import ToggleNavbar from "../Toggle/Navbar";
import TimeTicker from "../../../components/Utils/TimeTicker";
import { useLayout, useLayoutUpdate } from "./../LayoutProvider";
import { useTranslation } from "react-i18next";
import { logout } from "../../../services/authService";
import { Link } from "react-router-dom";
import { FaShoppingCart } from "react-icons/fa"; // Import FontAwesome cart icon
import { Badge } from "react-bootstrap"; // Import Bootstrap badge
import Modal from 'react-bootstrap/Modal';
import { FaClipboardList } from 'react-icons/fa';
import Swal from 'sweetalert2';
import { FaSyncAlt } from 'react-icons/fa';
import { FaLock } from 'react-icons/fa';
import { FaInfoCircle } from 'react-icons/fa';
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { FaGift } from "react-icons/fa";
import {
  MDBCol,
  MDBContainer,
  MDBRow,
  MDBCard,
  MDBCardText,
  MDBCardBody,
  MDBCardImage,
  MDBBtn,
  MDBBreadcrumb,
  MDBBreadcrumbItem,
} from "mdb-react-ui-kit";
import axios from 'axios';

const baseURL = process.env.REACT_APP_API_BASE_URL_MASTER_DATA;

function QuickNav({ className, ...props }) {
  const compClass = classNames({
    "nk-quick-nav": true,
    [className]: className,
  });
  return <ul className={compClass}>{props.children}</ul>;
}

function QuickNavItem({ className, ...props }) {
  const compClass = classNames({
    "d-inline-flex": true,
    [className]: className,
  });
  return <li className={compClass}>{props.children}</li>;
}

function Header({ show, ...props }) {
  const navigate = useNavigate();
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [showMark, setShowMark] = useState("");
  const [data, setData] = useState({
    marketId: localStorage.getItem("marketId"),
    godownId: localStorage.getItem("godownId")
      ? localStorage.getItem("godownId")
      : "",
  });
  const [search, setSearch] = useState('');
  const [results, setResults] = useState([]);
  const [showMenu, setShowMenu] = useState(false);
  const [error, setError] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const wrapperRef = useRef(null); const [marketName, setMarketName] = useState("");
  const [godownListData, setGodownListData] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const loggedInStatus = localStorage.getItem("isLoggedIn") === "true";
    setIsLoggedIn(loggedInStatus);
  }, []);

  useEffect(() => {
    if (show) {
      setShowMark(show === "true");
    } else {
      setShowMark(false);
    }
  }, [show]);

  useEffect(() => {
    if (data.marketId) {
      // getGodownList(data.marketId);
    }
  }, [data.marketId]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [username, setUsername] = useState('');
  useEffect(() => {
    const storedUsername = localStorage.getItem('user_name');
    if (storedUsername) {
      setUsername(storedUsername);
    }
  }, []);

  const handleClick = () => {
    navigate('/shop'); // Navigate to the specified route
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleSearch = async (e) => {
    const query = e.target.value;
    setSearch(query);

    if (query.trim() === '') {
      setResults([]);
      setShowDropdown(false);
      return;
    }

    try {
      const authToken = localStorage.getItem("authToken");
      const response = await axios.get(`${process.env.REACT_APP_HOST}api/combo-search`, {
        headers: { Authorization: `Bearer ${authToken}` },
        params: { search: query },
      });

      if (response.data.success) {
        setResults(response.data.data.slice(0, 10));
        setShowDropdown(true);
      }
    } catch (error) {
      console.error('Search error:', error);
    }
  };

  const handleSelect = (id) => {
    setSearch('');
    setResults([]);
    setShowDropdown(false);
    navigate(`/shop/combo/${id}`);
  };
  const handleLogout = () => {
    localStorage.clear();
    navigate("/shop/auths/login");
    localStorage.removeItem("isLoggedIn");
    setIsLoggedIn(false);
  };

  const handleLogin = () => {
    navigate("/shop/auths/login");
    localStorage.setItem("isLoggedIn", "true");
    setIsLoggedIn(true);
  };

  const handleCustomerRegister = () => {
    navigate("/shop/auths/customer-register");
  };

  const handleSupplierRegister = () => {
    navigate("/shop/auths/supplier-register");
  };

  const handleToggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const handleInputs = (e) => {
    let { name, value } = e.target;
    setData({ ...data, [name]: value });
    if (name === "godownId") {
      api
        .post(baseURL + `userPreference/edit`, {
          userMasterId: localStorage.getItem("userMasterId"),
          godownId: value,
        })
        .then((res) => {
          const isTrue = res.data.content.error;
          if (!isTrue) {
            localStorage.setItem("godownId", value);
          }
        });
    }
  };

  const getMarketList = () => {
    api
      .get(baseURL + `marketMaster/get/${data.marketId}`)
      .then((response) => {
        setMarketName(response.data.content.marketMasterName);
      })
      .catch((err) => { });
  };

  useEffect(() => {
    // getMarketList();
  }, []);

  const [modalReferralShow, setModalReferralShow] = useState(false);

  const handleClose = () => setModalReferralShow(false);
  const handleShow = () => setModalReferralShow(true);

  const layout = useLayout();
  const layoutUpdate = useLayoutUpdate();

  const compClass = classNames({
    "nk-header nk-header-fixed": true,
    [`is-${layout.headerVariant}`]: layout.headerVariant,
  });

  const navClass = classNames({
    "nk-header-menu nk-navbar": true,
    "navbar-active": layout.headerActive,
    "navbar-mobile":
      layout.headerTransition ||
      layout.breaks[layout.headerCollapse] > window.innerWidth,
  });

  const handleOffcanvasClose = () => setShowOffcanvas(false);
  const handleOffcanvasShow = () => setShowOffcanvas(true);

  const { t, i18n } = useTranslation();
  const [leftHovered, setLeftHovered] = useState(false);
  const [middleHovered, setMiddleHovered] = useState(false);
  const [rightHovered, setRightHovered] = useState(false);

  const [showLegModal, setShowLegModal] = useState(false);
  const [showUrlModal, setShowUrlModal] = useState(false);  // State for Referral URL Modal after leg selection
  const [selectedLeg, setSelectedLeg] = useState(null);  // Track selected leg for the URL

  const userId = localStorage.getItem('user_id');
  const [userUrl, setUserUrl] = useState(""); // Will hold the updated referral URL

  const handleCloseLegModal = () => setShowLegModal(false);  // Close Leg Selection Modal
  const handleCloseUrlModal = () => setShowUrlModal(false);  // Close URL Modal
  const handleShowUrlModal = () => setShowUrlModal(true);    // Show URL Modal after leg selection

  // Function to check if user has completed at least one order
  const checkUserOrders = async () => {
    const authToken = localStorage.getItem("authToken");
    try {
      const response = await fetch(`${process.env.REACT_APP_HOST}api/orders/userOrders?user_id=${userId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = await response.json();

      if (data.success && Array.isArray(data.data) && data.data.length > 0) {
        return true; // User has orders
      } else {
        Swal.fire({
          imageUrl: "/shop/images/Ordernotfound.svg",
          imageWidth: '100%',
          imageHeight: 'auto',
          imageAlt: "Order Not Found",
          title: 'No Orders Found',
          text: 'You need to complete at least one order to access this feature.',
          timer: 5000, // 5 seconds
          timerProgressBar: true,
          showConfirmButton: false
        }).then(() => {
          // Navigate after the alert closes
          navigate("/shop/auths/orders");
        });
        return false; // User has no orders
      }
    } catch (err) {
      console.error("Error fetching orders:", err);
      setError("Failed to fetch orders. Please try again.");
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong. Please try again.",
      });
      return false;
    }
  };

  const handleShowLegModal = async () => {
    const hasOrders = await checkUserOrders();
    if (hasOrders) {
      setShowLegModal(true);
    }
  };

  const handleProfileClick = async () => {
    const hasOrders = await checkUserOrders();
    if (hasOrders) {
      navigate("/shop/auths/user-profile-page");
    }
  };

  const handleSelectLeg = (selectedLeg) => {
    setSelectedLeg(selectedLeg); // Set selected leg
    const newUrl = `${process.env.REACT_APP_API_URL}shop/auths/registration/${userId}?Team=${selectedLeg}`;
    setUserUrl(newUrl);
    handleCloseLegModal();  // Close the leg selection modal
    handleShowUrlModal();  // Show the URL modal after selecting leg
  };

  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(userUrl).then(() => {
      handleCloseUrlModal();
      Swal.fire({
        imageUrl: "/shop/images/Success2.svg",
        imageWidth: '100%',
        imageHeight: 'auto',
        imageAlt: "Success Image",
        title: 'URL copied to clipboard!',
        showConfirmButton: false,
        timer: 1500,
      });
    }).catch(err => {
      Swal.fire({
        icon: 'error',
        title: 'Failed to copy',
        text: err.message,
        showConfirmButton: true
      });
    });
  };

  const handleNavigateToProfile = () => {
    handleCloseLegModal(); // Close the modal first
    navigate("/shop/auths/user-profile-page?tab=tabThree");
  };

  return (
    <>
      <div
        className={compClass}
        style={{
          position: 'fixed',
          top: 0,
          width: '100%',
          zIndex: 1000,
          backgroundColor: "rgb(255, 255, 255)",
          height: '60px',
        }}
      >
        <div style={{ padding: "6px 14px 4px 20px", backgroundColor: "rgb(255, 255, 255)", }}>
          <div className="d-flex align-items-center">
            <button onClick={handleClick} style={{ background: 'none', border: 'none' }}>
              <img
                src={
                  process.env.PUBLIC_URL + "/images/elite-main1.png"
                }
                alt="Logo"
                style={{
                  height: "auto",
                  width: 150,
                }}
              />
            </button>
            <div
              className="ms-3"
              style={{
                paddingLeft: "10px",
                fontWeight: "bold",
                fontSize: "18px",
              }}
            >
            </div>
            <br />
            <br />
            <div style={{ marginLeft: "auto" }}>
              <div className="nk-header-tools">
                <QuickNav>
                  {showMark && (
                    <>
                      <span className="me-5 d-flex align-items-center">
                        <span style={{ fontWeight: "bold" }}>
                          Market Name:{" "}
                        </span>
                        <span style={{ fontWeight: "bold", color: "green" }}>
                          {marketName}
                        </span>
                      </span>
                      <div className="me-5 d-flex justify-content-between align-items-center">
                        <Form.Label column sm={2}>
                          Godown:
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Select
                            name="godownId"
                            value={data.godownId}
                            onChange={handleInputs}
                          >
                            <option value="">Select Godown</option>
                            {godownListData.map((list) => (
                              <option key={list.godownId} value={list.godownId}>
                                {list.godownName}
                              </option>
                            ))}
                          </Form.Select>
                        </Col>
                      </div>
                    </>
                  )}

                  <QuickNav>
                    <div ref={wrapperRef}>
                      <Dropdown
                        as={QuickNavItem}
                        show={showMenu}
                        onToggle={() => { }}
                      >
                        <Dropdown.Toggle
                          variant="zoom"
                          size="sm"
                          bsPrefix
                          className="btn-icon d-sm-none"
                          onClick={() => setShowMenu((prev) => !prev)}
                        >
                          <Icon name="search" />
                        </Dropdown.Toggle>

                        <Dropdown.Toggle
                          variant="zoom"
                          size="md"
                          bsPrefix
                          className="btn-icon d-none d-sm-inline-flex"
                          onClick={() => setShowMenu((prev) => !prev)}
                        >
                          <Icon name="search" />
                        </Dropdown.Toggle>

                        {showMenu && (
                          <Dropdown.Menu className="dropdown-menu-lg show">
                            <div className="dropdown-content dropdown-content-x-lg py-1">
                              <div className="search-inline">
                                <div className="form-control-wrap flex-grow-1">
                                  <input
                                    placeholder="Search Products"
                                    type="text"
                                    className="form-control-plaintext"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    onKeyUp={handleSearch}
                                    autoFocus
                                  />
                                </div>
                                <Icon name="search" size="sm" />
                              </div>
                            </div>

                            <Dropdown.Divider className="m-0" />
                            <div className="dropdown-content dropdown-content-x-lg py-3">
                              <ul className="dropdown-list gap gy-2">
                                {results.map((item) => (
                                  <li
                                    key={item.id}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleSelect(item.id)}
                                  >
                                    <MediaGroup>
                                      <MediaText>
                                        <div className="lead-text">{item.name}</div>
                                      </MediaText>
                                      <MediaAction end>
                                        <Button size="md" variant="zoom" className="btn-icon me-n1">
                                          <Icon name="arrow-right" />
                                        </Button>
                                      </MediaAction>
                                    </MediaGroup>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </Dropdown.Menu>
                        )}
                      </Dropdown>
                    </div>
                  </QuickNav>
                  <Dropdown as={QuickNavItem}>
                    <Dropdown.Toggle bsPrefix as={CustomDropdownToggle}>
                      <div className=" d-sm-flex">
                        <Media shape="circle">
                          <Image
                            src="/images/avatar/profile-img.png"
                            staticImage
                            thumbnail
                          />
                        </Media>
                      </div>
                    </Dropdown.Toggle>
                    <Dropdown.Menu
                      className="dropdown-menu-md"
                      as={CustomDropdownMenu}
                    >
                      <div className="dropdown-content dropdown-content-x-lg py-3 border-bottom border-light">
                        <MediaGroup>
                          <Media size="xl" shape="circle">
                            <Image
                              src="/images/avatar/profile-img.png"
                              staticImage
                              thumbnail
                            />
                          </Media>
                          <MediaText>
                            <div className="media-text">
                              <div className="lead-text">
                                {username ? username : 'Guest'}
                              </div>
                            </div>
                          </MediaText>
                        </MediaGroup>
                      </div>
                      <div className="dropdown-content dropdown-content-x-lg py-3 border-bottom border-light">
                        <LinkList>
                          <div
                            onClick={handleProfileClick}
                            style={{
                              display: 'flex',
                              cursor: 'pointer'
                            }}
                          >
                            <Icon name="user"></Icon>
                            <span style={{ marginLeft: '8px' }}>My Profile</span>
                          </div>
                          <LinkListItem to="/shop/auths/orders">
                            <Icon name="file-text"></Icon>
                            <span>Orders</span>
                          </LinkListItem>

                          <MDBRow className="mt-2">
                            <MDBCol>
                              <MDBCol style={{ width: "200px" }}>
                                <MDBBtn
                                  onClick={handleShowLegModal}
                                  className="d-flex align-items-center justify-content-center fixed-btn custom-referral-btn"
                                >
                                  <div className="d-flex align-items-center gap-2">
                                    <FaGift className="icon" />
                                    <span>Referral Link</span>
                                  </div>
                                </MDBBtn>
                              </MDBCol>
                            </MDBCol>
                          </MDBRow>
                        </LinkList>
                      </div>
                      <div className="dropdown-content dropdown-content-x-lg py-3">
                        {isLoggedIn ? (
                          <Button variant="link" onClick={handleLogin}>
                            <Icon name="signin" />
                            <span>Login</span>
                          </Button>
                        ) : (
                          <>
                            <Button variant="link" onClick={handleLogout}>
                              <Icon name="signout" />
                              <span>Log Out</span>
                            </Button>
                          </>
                        )}
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </QuickNav>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Leg Selection Modal */}
      <Modal show={showLegModal} onHide={handleCloseLegModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Select Team</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-center flex-column align-items-center">
            <div className="mb-4" style={{ fontSize: "20px", fontWeight: "bold" }}>
              {username}
            </div>
            <div className="d-flex justify-content-center gap-3 mb-4">
              <Button
                variant="primary"
                onClick={() => handleSelectLeg(0)}
                style={{
                  backgroundColor: "#0d6efd",
                  borderColor: "#0d6efd",
                  width: "70px"
                }}
                onMouseEnter={() => setLeftHovered(true)}
                onMouseLeave={() => setLeftHovered(false)}
              >
                Blue Team
              </Button>
              <Button
                variant="warning"
                onClick={() => handleSelectLeg(1)}
                style={{
                  backgroundColor: "#ffc107",
                  borderColor: "#ffc107",
                  color: "#000",
                  width: "70px"
                }}
                onMouseEnter={() => setMiddleHovered(true)}
                onMouseLeave={() => setMiddleHovered(false)}
              >
                Yellow Team
              </Button>
              <Button
                variant="success"
                onClick={() => handleSelectLeg(2)}
                style={{
                  backgroundColor: "#198754",
                  borderColor: "#198754",
                  width: "70px"
                }}
                onMouseEnter={() => setRightHovered(true)}
                onMouseLeave={() => setRightHovered(false)}
              >
                Green Team
              </Button>
              <Button
                variant="primary"
                onClick={handleNavigateToProfile}
                style={{ width: "70px" }}
              >
                Profile
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Dialog open={showUrlModal} onClose={handleCloseUrlModal}>
        <DialogTitle>Refer and Earn</DialogTitle>
        <DialogContent>
          <div>{userUrl}</div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseUrlModal} color="secondary">
            Close
          </Button>
          <Button onClick={handleCopyToClipboard} color="primary">
            Copy
          </Button>
        </DialogActions>
      </Dialog>

      <Offcanvas
        className="offcanvas-size-lg"
        placement="end"
        show={showOffcanvas}
        onHide={handleOffcanvasClose}
      >
        <Offcanvas.Header closeButton className="border-bottom border-light">
          <Offcanvas.Title>Recent Notification</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <SimpleBar></SimpleBar>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default Header;